export const environment = {
    production: false,
    apiURL: 'https://rms.jijifest.com',
    apiVersion: 'api',
    fileServerURL: 'https://rms.jijifest.com/fileserver'
};
